<template>
	<div class="recommend-container">
		<Slide
			:dataList="slideData"
			:appid="appid"
			:servicePageData="servicePageData"
			:userGuideFeature="userGuideFeature"
		/>
	</div>
</template>

<script>
import Slide from './slide.vue'

export default {
	props: {
		recommendContent: {
			type: String,
			default: '推荐服务',
		},
		services: {
			type: Array,
			default: () => [],
		},
		appid: {
			type: String,
			default: '',
		},
		servicePageData: {
			type: Object,
			default: null,
		},
		userGuideFeature: {
			type: Object,
			default: null,
		},
		
	},
	components: {
		Slide,
	},
	data() {
		return {
			slideData: [],
		}
	},
	methods: {
		formatServicesForSlide(services, pageSize = 7) {
			const result = []
			const totalPages = Math.ceil(services.length / pageSize)

			for (let i = 0; i < totalPages; i++) {
				const start = i * pageSize
				const end = start + pageSize
				const pageData = services.slice(start, end)

				result.push({
					children: pageData,
				})
			}

			return result
		},
	},
	watch: {
		services: {
			handler(newValue) {
				this.slideData = this.formatServicesForSlide(newValue)
			},
			immediate: true,
		},
	},
}
</script>
<style scoped lang="less">
.recommend-container {
	width: 100%;
	background-color: #fff;
	.px2rem(border-radius, 12);
	.px2rem(padding, 6);
	.px2rem(padding-right, 12);
	.px2rem(padding-bottom, 5);
	box-sizing: border-box;
	.px2rem(margin-bottom, 24);
}
</style>
